import Vue from 'vue'
import _NotFound from './NotFound.vue'

export const NotFound = Vue.component('not-found', _NotFound)